import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CREDITOPTION,
  DELETE_CREDITOPTION,
  UPDATE_CREDITOPTION,
  ADD_NEW_CREDITOPTION,
} from "./actionType";

import {
  getCreditOptionSuccess,
  getCreditOptionFail,
  deleteCreditOptionSuccess,
  deleteCreditOptionFail,
  updateCreditOptionSuccess,
  updateCreditOptionFail,
  addCreditOptionSuccess,
  addCreditOptionFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveCreditOptionApi,
  getCreditOptionApi,
  updateCreditOptionApi,
  deleteCreditOptionApi,
  addNewCreditOptionApi
} from "../../helpers/backend_helper";

function* getCreditOption({ payload: creditOption }) {
  try {
    const response = yield call(getCreditOptionApi, creditOption);
    yield put(getCreditOptionSuccess(GET_CREDITOPTION, response.data));
  } catch (error) {
    yield put(getCreditOptionFail(GET_CREDITOPTION, error));
  }
}

function* onUpdateCreditOption({ payload: creditOption }) {
  try {
    if (creditOption.setApprove) {
      const response = yield call(approveCreditOptionApi, creditOption);
      yield put(updateCreditOptionSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCreditOptionApi, creditOption);
      yield put(updateCreditOptionSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCreditOptionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCreditOption({ payload: creditOption }) {
  try {
    const response = yield call(deleteCreditOptionApi, creditOption);
    yield put(deleteCreditOptionSuccess({ creditOption, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCreditOptionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCreditOption({ payload: creditOption }) {
  try {
    const response = yield call(addNewCreditOptionApi, creditOption);
    yield put(addCreditOptionSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCreditOptionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCreditOption() {
  yield takeEvery(GET_CREDITOPTION, getCreditOption);
}

export function* watchUpdateCreditOption() {
  yield takeEvery(UPDATE_CREDITOPTION, onUpdateCreditOption);
}

export function* watchDeleteCreditOption() {
  yield takeEvery(DELETE_CREDITOPTION, onDeleteCreditOption);
}

export function* watchAddNewCreditOption() {
  yield takeEvery(ADD_NEW_CREDITOPTION, onAddNewCreditOption);
}

function* creditOptionSaga() {
  yield all([
    fork(watchGetCreditOption),
    fork(watchDeleteCreditOption),
    fork(watchUpdateCreditOption),
    fork(watchAddNewCreditOption)
  ]);
}

export default creditOptionSaga;
